import { SigninState } from 'oidc-client-ts';
import { useCallback, useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import { createSearchParams } from 'react-router-dom';
import { AppAuthProviderContext } from '../components';
import { clearLocalStorage } from '../utils';

type AppType = 'sr' | 'compliance' | 'selector';

export const useLogout = ({
  onRemoveQueries,
}: { onRemoveQueries?: () => void; appType?: AppType } = {}) => {
  const auth = useAuth();
  const { preservedLocalStorageKeys } = useContext(AppAuthProviderContext);

  return useCallback(
    async (redirectUrl?: string) => {
      auth.signoutSilent();

      // const prev_page = `${window.location.origin}${window.location.pathname}?${window.location.search.toString()}`;

      const codeChallenge =
        (
          await SigninState.create({
            code_verifier: true,
            authority: auth.settings.authority,
            client_id: auth.settings.client_id,
            redirect_uri:
              redirectUrl || import.meta.env.VITE_APP_SELECTOR_URL || auth.settings.redirect_uri,
            scope: auth.settings.scope || 'openid profile email organization roles',
          })
        ).code_challenge || '';

      const postLogOutRedirectParams = createSearchParams({
        client_id: auth.settings.client_id,
        redirect_uri:
          redirectUrl || import.meta.env.VITE_APP_SELECTOR_URL || auth.settings.redirect_uri,
        response_type: 'code',
        scope: 'openid profile email organization roles',
        code_challenge_method: 'S256',
        code_challenge: codeChallenge,
      }).toString();

      setTimeout(() => {
        if (auth.settings.post_logout_redirect_uri) {
          onRemoveQueries && onRemoveQueries();
          clearLocalStorage([...preservedLocalStorageKeys]);
          sessionStorage.clear();

          window.location.replace(
            `${auth.settings.post_logout_redirect_uri}?${postLogOutRedirectParams}`,
          );
        }
      }, 400);
    },
    [auth, onRemoveQueries, preservedLocalStorageKeys],
  );
};
